import { useAuth } from '../AuthenticatedApp';

// Custom hook to fetch venue ID
export const useVenueId = () => {
  const { venueId } = useAuth();
  return venueId;
};

// Note: useAreaId, useUserRoles, useUserPermissions removed - not used in admin panel